import React from "react";
import { InsertTabulador, mountTabulatorReduce } from "../actions";
import { connect } from "react-redux";
import { Popover } from "../actions/Tippy";
import _ from "lodash";
import DropdownTreeSelect from "react-dropdown-tree-select";
import SUCCESS from "../build/images/tabulacao-sucesso.svg";
import { ReactComponent as IconTabulator } from "../build/images/attendanceIcons/task.svg";

var selectedNodesTree = [];

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
    Tabulador: state.tabulator,
    ContactId: state.atendimento,
  };
};

const mapDispatchToProps = (dispatch) => ({
  InsertTabulatorBase: (todo1, todo2) => {
    dispatch(InsertTabulador(todo1, todo2));
  },
  mountTabulatorReduce: (array) => {
    dispatch(mountTabulatorReduce(array));
  },
});

class Tabulator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryArray: [],
      user: props.InfoUsers ? props.InfoUsers : "",
      textTyped: "",
      isLoading: false,
      conclused: false,
      emptyOptions: false,
    };
  }

  onChange(currentNode, selectedNodes) {
    selectedNodesTree = selectedNodes;
  }

  toSaveTabulator() {
    if (selectedNodesTree.length > 0) {
      const textTyped = document.getElementById("service-tab-text").value;
      // const { user } = this.state;
      // const { currentService } = this.props;
      this.setState({ emptyOptions: false });
      this.setState({ isLoading: true });

      this.props.InsertTabulatorBase(selectedNodesTree, textTyped);

      this.setState({ isLoading: false });
      document.getElementById("service-tab-text").value = "";
      selectedNodesTree = [];
      this.setState({ conclused: true });

      setTimeout(() => {
        this.setState({ conclused: false });
        // setTimeout(() => {
        //   document.getElementById("simulation_click").click();
        // }, 500)
      }, 5000);
    } else {
      this.setState({ emptyOptions: true });

      setTimeout(() => {
        this.setState({ emptyOptions: false });
      }, 3000);
    }
  }

  renderPopover = (e, Tabulador) => (
    <div id="service-tab">
      <div className="block-header__service-tab-box service-tab">
        <div className="block-header__service-tab-content">
          <div className="service-tab__header">Tabulação</div>
          <div
            className="service-tab__content"
            style={{ display: this.state.conclused ? "none" : "block" }}
          >
            <div className="service-tab__content--main">
              <div className="service-tab__block is-1">
                <DropdownTreeSelect
                  className="iw-tree-select"
                  data={Tabulador.three}
                  texts={{ placeholder: "Pesquisar" }}
                  keepTreeOnSearch={true}
                  keepChildrenOnSearch={true}
                  onChange={(currentNode, selectedNodes) => {
                    this.onChange(currentNode, selectedNodes);
                  }}
                />
              </div>
              <div className="service-tab__block is-4">
                <textarea
                  className="service-tab__textarea"
                  name="service-tab-text"
                  id="service-tab-text"
                ></textarea>
              </div>
              <div className="service-tab__block is-1">
                {this.state.emptyOptions && (
                  <div
                    className="service-tab__btn-warning"
                    style={{ padding: 8 }}
                  >
                    <span>Escolha alguma opção para salvar.</span>
                  </div>
                )}
                <div className="service-tab__btn-box">
                  <button
                    className={`service-tab__btn service-tab__btn--save service-tab__btn--blue
                    `}
                    onClick={() => this.toSaveTabulator(this)}
                  >
                    Salvar
                  </button>
                  <button
                    className="service-tab__btn service-tab__btn--cancel"
                    onClick={() =>
                      document.getElementById("simulation_click").click()
                    }
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>

            <div className="service-tab__content--secondary">
              <div className="service-tab__block is-4">
                <img
                  src="build/images/add-note-success.png"
                  alt=""
                  className="service-tab__img"
                />
                <p className="service-tab__text is-blue is-20 is-poppins mg-top-10">
                  Sua anotação foi salva
                  <em className="is-poppins is-poppins--bold">com sucesso!</em>
                </p>
              </div>
              <div className="service-tab__block is-1">
                <a
                  href="#"
                  className="service-tab__btn service-tab__btn--back service-tab__btn--blue pd-top-10"
                >
                  Voltar para o chat
                </a>
              </div>
            </div>
          </div>
          <div
            className="service-tab__content--main service-tab__content--success"
            style={{ display: this.state.conclused ? "block" : "none" }}
          >
            <br />
            <div className="service-tab__block is-4">
              <img src={SUCCESS} alt="" className="service-tab__img" />

              <p className="service-tab__text is-blue is-20 is-poppins mg-top-10">
                Sua tabulação foi salva
                <em className="is-poppins is-poppins--bold">com sucesso!</em>
              </p>
            </div>

            <div className="service-tab__block is-1">
              <a
                href="#"
                className="service-tab__btn service-tab__btn--back service-tab__btn--blue pd-top-10"
                onClick={() => this.setState({ conclused: false })}
              >
                Voltar para o chat
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const { Tabulador, InfoUsers, ContactId } = this.props;

    return (
      <Popover
        trigger="click"
        interactive={true}
        content={this.renderPopover(this, Tabulador)}
      >
        <button
          type="button"
          className={`btn action with-icon tippy-popover not-clicable-tooltip ${
            InfoUsers.classificationcount > 0 && ContactId.isTabulation !== true
              ? "hover"
              : ""
          } ${Tabulador.three.length === 0 ? "disabled" : ""}`}
          id="chat-action-add-tabulator"
          data-tooltip="Tabulador de Atendimento"
          data-template="service-tab"
        >
          {/* <i className="material-icons">local_offer</i> */}
          <IconTabulator />
        </button>
      </Popover>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tabulator);
